// extracted by mini-css-extract-plugin
export default {"sessionSaleContent":"src-modules-page-blocks-SessionSaleContent-style__sessionSaleContent_fFvpU"};